<template>
  <section class="hider">
    <button class="main" @click="visible = !visible" :disabled="!enabled">
      {{ prefix }} <slot name="label"></slot>
    </button>
    <div class="always"><slot name="always"></slot></div>
    <div class="maybe" v-if="visible"><slot></slot></div>
  </section>
</template>

<script>
export default {
    props: {
    enabled: {
        type: Boolean,
        default: true,
    },
    prefixOn: {
        type: String,
        default: "-",
    },
    prefixOff: {
        type: String,
        default: "+",
    },
    initiallyVisible: {
        default: false,
        type: Boolean
    }
},
    computed: {
      prefix () { return this.visible ? this.prefixOn : this.prefixOff; },
    },
    data () {
        return {
            visible: this.initiallyVisible,
        }
    }
}
</script>

<style>
  .hider {}
  .hider > button {
      width: 100%;
  }

  .hider button.main { width: 100%; }

</style>

<doc>
  hider SFC: components to hide the slots passed in the template
</doc>
